import { Link } from "gatsby";
import React from "react";
import CustomLink from "../../common/link";

const isLinkValid = (link) => {
  if (!link?.linkTitle) return false;
  switch (link.linkType) {
    case "slug":
      return Boolean(link?.slug?.current);
    case "url":
      return Boolean(link?.url);
    case "popup":
      return Boolean(link?.file?.asset?.url);
    case "sectionId":
      return Boolean(link?.sectionId);
    default:
      return false;
  }
};

const NavMenu = ({ menu, openPopup, setPdf }) => {
  return (
    <ul className="mb-0 pl-0">
      {menu?.map((menuItem, index) => {
        if (menuItem.itemType === "category") {
          if (!menuItem?.category?.name || !menuItem?.category?.slug?.current) {
            return null;
          }
          return (
            <li
              key={index}
              className={`${
                menuItem?.tags?.length > 0
                  ? "active menu-item-has-children"
                  : "mega-menu"
              }`}
            >
              <Link
                to={`/${menuItem.category.slug.current}`}
                className="text-inherit no-underline font-medium"
              >
                {menuItem.category.name}
              </Link>

              {menuItem?.tags?.length > 0 && (
                <ul className="sub-menu">
                  {menuItem?.tags?.map((tag, subIndex) => {
                    if (
                      !tag?.name ||
                      !tag?.slug?.current ||
                      !tag?.category?.slug?.current
                    ) {
                      return null;
                    }
                    return (
                      <li key={subIndex}>
                        <Link
                          to={`/${tag.category.slug.current}/tag/${tag.slug.current}`}
                          className="text-inherit no-underline font-medium"
                        >
                          {tag.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        } else if (menuItem.itemType === "none") {
          if (!menuItem?.menuTitle) {
            return null;
          }
          return (
            <li
              key={index}
              className={`${
                menuItem?.links?.some(isLinkValid)
                  ? "active menu-item-has-children"
                  : "mega-menu"
              }`}
            >
              <span className="text-inherit no-underline font-medium cursor-pointer">
                {menuItem.menuTitle}
              </span>
              {menuItem?.links?.some(isLinkValid) && (
                <ul className="sub-menu">
                  {menuItem?.links?.map((link, subIndex) => {
                    if (!isLinkValid(link)) {
                      return null;
                    }
                    return (
                      <li key={subIndex}>
                        <CustomLink
                          data={link}
                          classNames="text-inherit no-underline font-medium"
                          openPopup={() => openPopup(true)}
                          setPdf={setPdf}
                        />
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        } else if (menuItem.itemType === "link") {
          if (!menuItem?.menuTitle || !menuItem?.menuLink?.current) {
            return null;
          }
          return (
            <li
              key={index}
              className={`${
                menuItem?.links?.length > 0 ? "active" : "mega-menu"
              }`}
            >
              <Link
                to={
                  menuItem.menuLink.current.startsWith("/")
                    ? menuItem.menuLink.current
                    : `/${menuItem.menuLink.current}`
                }
                className="text-inherit no-underline font-medium cursor-pointer"
              >
                {menuItem.menuTitle}
              </Link>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default NavMenu;
